<template>
  <div>
    <p class="section-label" :style="order > 1 && 'padding-top: 1.25rem'">{{ label }}</p>
    <div v-html="item" />
  </div>
</template>

<script>
export default {
  name: 'rich-text-description-label',
  props: {
    label: {
      type: String,
      default: null,
    },
    item: {
      type: String,
      default: '',
    },
    order: {
      type: Number,
      default: null,
    },
  },
}
</script>

<style scoped>
.section-label {
  font-family: 'Raleway';
  font-size: 1.25rem;
  line-height: 2rem;
  font-weight: bold;
  margin-bottom: 0px !important;
  padding-bottom: 1.25rem;
  color: #0277bd;
}
</style>
